import { Stack } from '@mui/material';
import { StationRequestForm } from '../../components/forms/StationReguestForm/StationRequestForm';
import { BackButton } from '../../components/common/Button/BackButton/BackButton';

export const StationRequest = () => {
  return (
    <Stack
      sx={{
        padding: '14px 8px',
        maxWidth: '400px',
        width: '100%',
        gap: '14px',
      }}
    >
      <BackButton skipReloadPage />
      <StationRequestForm />
    </Stack>
  );
};
